module.exports = __webpack_public_path__ + "static/media/loading.0825bd93.mp4";